import { css } from '@emotion/css';

const card = css`
  .MuiCard-root {
    width: 280px;
    height: 100%;
    border-radius: var(--radius-2);
    box-shadow: none;
    background-color: var(--colors-primary-100);
    border: 1px solid var(--colors-primary-100);

    &:hover {
      border-color: var(--colors-primary-500);
    }

    .MuiCardActionArea-root {
      padding: var(--spacings-4);
      height: 100%;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      align-items: flex-start;
    }

    .MuiCardContent-root {
      padding: 0;
    }
  }
`;

const cardContent = css`
  display: flex;
  justify-content: space-between;
  width: 100%;
  color: var(--colors-primary-400);

  & > .MuiBox-root:first-child {
    & .MuiTypography-h6 {
      font-weight: var(--text-weights-bold);
    }

    & .MuiTypography-body2 {
      font-weight: var(--text-weights-semi-bold);
    }
  }

  & > .MuiBox-root:last-child {
    width: var(--dimensions-6);
    height: var(--dimensions-6);
    border-radius: var(--radius-5);
    background-color: var(--colors-primary-400);
  }
`;

const buttonToCreateWallet = css`
  display: flex;
  align-items: center;
  gap: var(--spacings-3);
  color: var(--colors-primary-500);

  .MuiIconButton-root {
    background-color: var(--colors-primary-500);
    cursor: pointer;
    color: white;
    height: var(--dimensions-10);
    width: var(--dimensions-10);
    &:hover {
      background-color: var(--colors-primary-700);
    }
  }

  & > .MuiTypography-root {
    font-weight: var(--text-weights-bold);
  }
`;

const CreateWalletCardStyles = {
  card,
  cardContent,
  buttonToCreateWallet,
};

export default CreateWalletCardStyles;
